// extracted by mini-css-extract-plugin
export default {"changeRoleModal":"ChangeRoleModal_changeRoleModal__74rDf","amount":"ChangeRoleModal_amount__FCiiC"};